import React, { useRef } from "react";
import ChatPage from "./ChatPage";
import Draggable from "react-draggable";
import "../styles/ChatModal.css";

const ChatModal = ({ onClose }) => {
  const nodeRef = useRef(null);

  return (
    <div className="chat-modal-backdrop">
      <Draggable handle=".chat-modal-header" nodeRef={nodeRef}>
        <div className="chat-modal-content" ref={nodeRef}>
          <div className="chat-modal-header">
            <span className="chat-title">💬 챗봇</span>
            <button className="chat-close-button" onClick={onClose}>
              ✖
            </button>
          </div>
          <div className="chat-modal-body">
            <ChatPage />
          </div>
        </div>
      </Draggable>
    </div>
  );
};
export default ChatModal;
